import { DateTime } from "luxon";

export function handleFormatDate(dateString: any, withTime: boolean = true) {
  if (dateString == null) {
    return ""
  }

  dateString = dateString.trim()
  const dateTime = DateTime.fromISO(dateString);// DateTime.fromFormat(dateString, 'dd-MM-yyyy HH:mm:ss');

  // Check if the DateTime object is valid
  if (dateTime.isValid) {
    let dateFormat = 'dd-MMM-yy'

    if (withTime) {
      dateFormat = 'dd-MMM-yy, h:mm a'
    }

    const formattedDate = dateTime.toFormat(dateFormat)
    return formattedDate
  }

  return dateString
}

export function convertToISO(dateString) {
  dateString = handleFormatDate(dateString, false)
  // Parse the date string into a Luxon DateTime object
  let date = DateTime.fromFormat(dateString, 'dd/MM/yyyy');

  // Format the DateTime object as ISO 8601
  let isoString = date.toISO();

  return isoString;
}

// assume date is ISO string, time is 24 hours format
export function combineDateTime(date: string, time: any) {
  let assignDate = new Date(date)
  let timeSplit = time.split(':')

  if (timeSplit.length >= 2) {
    let hours = timeSplit[0]; 
    let minutes = timeSplit[1]

    // Set the hours and minutes on assignDate
    assignDate.setHours(hours, minutes, 0, 0); // Set hours, minutes, seconds, milliseconds
    assignDate.setMinutes(assignDate.getMinutes() - assignDate.getTimezoneOffset());
  }

  return assignDate.toISOString();
}

export function getFormattedDateTime(): { date: string; time: string } {
  const now: Date = new Date();

  const pad = (num: number): string => num.toString().padStart(2, '0');

  const dd = pad(now.getDate());
  const MM = pad(now.getMonth() + 1); // Month is 0-based
  const yyyy = now.getFullYear();

  const HH = pad(now.getHours());
  const mm = pad(now.getMinutes());
  const ss = pad(now.getSeconds());

  const date = `${dd}${MM}${yyyy}`;
  const time = `${HH}${mm}${ss}`;

  return { date, time };
}